import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';
import {Enterprise} from '../model/Enterprise';
import {Observable, of} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {LocalStorage} from '../../global/util/LocalStorage';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  private url = Constant.ROOT_API_V1.concat('/enterprises');

  constructor(private http: HttpClient) {
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public save(url: string, enterprise: Enterprise): Observable<Response> {
    return this.http.post<any>(url, JSON.stringify(enterprise), Headers.contentType);
  }

  public edit(enterprise: Enterprise): Observable<any> {
    return this.http.put(this.url, JSON.stringify(enterprise), Headers.contentType);
  }

  public delete(enterpriseId: number) {
    const url = this.url.concat('/', String(enterpriseId));
    return this.http.delete(url);
  }

  // Obtiene todas las empresas por el partnerId esto solo esta disponible para cargas empresa desde el filtro.
  public getEnterprisesByPartner(partnerId: number): Observable<Enterprise[]> {
    return of(LocalStorage.getEnterprisesExtraBy(partnerId));
  }

  // Obtiene todas las empresas y filtra por el partnerId esto solo esta disponible para cargas empresa desde el filtro.
  public getAllEnterprisesByPartner(partnerId: number): Observable<Enterprise[]> {
    return of(LocalStorage.getEnterprisesExtraBy(partnerId));
  }

  // Obtiene todas las empresas. Modal
  public getAllEnterprisesModal(): Observable<Enterprise[]> {
    return of(LocalStorage.getEnterprises());
  }

  // Obtiene todas las empresas por el partnerId, es usado para cargar la lista de empresas en modales o donde se requiera.
  public getEnterprisesByPartnerModal(partnerId: number): Observable<Enterprise[]> {
    return of(LocalStorage.getEnterprisesBy(partnerId));
  }

  public getAllEnterprises(): Observable<Enterprise[]> {
    return of(LocalStorage.getEnterprises());
  }
}
